import React from "react";
import styles from "./QuemSomos.module.css";

const QuemSomos = () => {
  return (
    <div className={styles.banner} data-aos="fade-up">
      <div className={styles.content}>
        <span className={styles.eyebrow}>Sobre nós</span>
        <h1 className={styles.title}>Quem Somos</h1>
        <p className={styles.subtitle}>
          Sempre destacando-se pela excelência do atendimento e assistência
          técnica, a ÍKONE é uma empresa que busca oferecer soluções
          consistentes e duradouras em automação, eletromecânica e TI — desde
          a análise das necessidades do cliente, seja desenvolvimento ou
          upgrades, até à startup.
        </p>
      </div>
    </div>
  );
};

export default QuemSomos;